import { PatientsRoute } from 'routes';

export const PatientDetailsRoute = `${PatientsRoute}/:id`;
export const PatientSettingsAndViewPreferencesRoute = `${PatientsRoute}/settings-and-view-preferences`;
